// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://localhost:3001/'
  // apiUrl: 'http://localhost:4731/'
  // apiUrl: 'http://193.203.163.20:4731/',
  // apiUrl: 'http://147.93.27.102:4731/'
  apiUrl: 'https://retailer.uzhavanconnect.com/'

  // apiUrl: 'http://192.168.1.39:3001/'
};
